'use strict';

export const getRelativeDate = ({ date, moment }) => {
  if (!date) {
    return null;
  }

  return (moment().diff(date, 'days') < 5)
    ? moment(date).fromNow()
    : moment(date).format('ll');
};

export const getAbsoluteDate = ({ date, moment }) => {
  if (!date) {
    return null;
  }

  return moment(date).format('llll');
};

export const getAbsoluteDateWithoutTime = ({ date, moment }) => {
  if (!date) {
    return null;
  }

  return moment(date).format('ll');
};
